import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin, } from '@amplitude/plugin-session-replay-browser';
// Exposed from its own entry (@repo/amplitude/session-replay), so only the apps
// that record sessions bundle the plugin (rrweb).
export default class SessionReplayHandler {
    static #instance;
    #plugin = null;
    constructor() { }
    static get instance() {
        if (!this.#instance)
            this.#instance = new SessionReplayHandler();
        return this.#instance;
    }
    start(options) {
        if (this.#plugin)
            return;
        this.#plugin = sessionReplayPlugin(options);
        amplitude.add(this.#plugin);
    }
    stop() {
        if (!this.#plugin)
            return;
        amplitude.remove(this.#plugin.name);
        this.#plugin = null;
    }
}
//# sourceMappingURL=session-replay-handler.js.map